import React from 'react';

const ContactUsPage = () => {
    return (
        <section className="contact-hero">
            <div className="contact-hero-content">
                <span className="contact-hero-subtitle">Contact Us</span>
                <h1 className="contact-hero-title">
                    <span>Let's discuss your requirements and</span> develop something unique. Get a free quote!
                </h1>
            </div>
        </section>
    );
};

export default ContactUsPage;
